import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Conference from "./components/conference/Conference";
import Login from "./components/login/Login";
import UserPortal from "./components/user-portal/UserPortal";
// import Dashboard from "./components/Dashboard/dashboard";
import { SiteProvider, useSiteContext } from "./context/SiteContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Recovery from "./components/Recovery/Recovery";
import RecoveryWithCode from "./components/Recovery/RecoveryWithCode";
import ForgotPassword from "./components/forgot-password/ForgotPassword";
import RoomNotFound from "./components/RoomNotFound";
import RecordingPreview from "./components/recording-preview/RecordingPreview";
import { MeetingProvider } from "./context/MeetingContext";
import { EditCtaProvider } from "./context/EditCtaContext";
import WebinerBrandingPre from "./components/webiner-branding/WebinerBrandingPre";
import WebinerBrandingPost from "./components/webiner-branding/WebinerBrandingPost";
import WebinerWaiting from "./components/webiner-branding/WebinerWaiting";
import MaintenanceNotification from "./components/MaintenanceNotification";

// Component to handle maintenance mode redirect
function MaintenanceModeGuard({ children }) {
  const { maintenanceMode } = useSiteContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // If maintenance mode is enabled and user is not already on the maintenance page
    if (maintenanceMode && location.pathname !== '/maintenance-notification') {
      // Allow access to login page even during maintenance
      if (location.pathname !== '/login') {
        navigate('/maintenance', { replace: true });
      }
    }
  }, [maintenanceMode, location.pathname, navigate]);

  return children;
}

function App() {
  return (
    <>
      <BrowserRouter>
        <SiteProvider>
          <MeetingProvider>
            <EditCtaProvider>
              <MaintenanceModeGuard>
                <Routes>
                  <Route path=":roomId" element={<Conference />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/recovery" element={<Recovery />} />
                  <Route path="/recoveryc" element={<RecoveryWithCode />} />
                  <Route
                    path="/webiner-branding-pre"
                    element={<WebinerBrandingPre />}
                  />
                  <Route
                    path="/webiner-branding-waiting"
                    element={<WebinerWaiting />}
                  />

                  <Route
                    path="/webiner-branding-post"
                    element={<WebinerBrandingPost />}
                  />
                  <Route
                    path="/maintenance"
                    element={<MaintenanceNotification />}
                  />

                  <Route path="/recoveryc" element={<RecoveryWithCode />} />
                  <Route path="/meeting-not-found" element={<RoomNotFound />} />
                  <Route
                    path="/recording-preview/:fileId"
                    element={<RecordingPreview />}
                  />
                  <Route
                    path="/dashboard/*"
                    element={
                      <ProtectedRoute>
                        <UserPortal />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
              </MaintenanceModeGuard>
            </EditCtaProvider>
          </MeetingProvider>
        </SiteProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
